module.exports = __webpack_public_path__ + "img/ponto-ooh.45f396aa.png";